module.exports = __webpack_public_path__ + "img/b08.7b254188.png";